export const CLEAR_INVESTOR_MANAGEMENT_STATE = 'CLEAR_INVESTOR_MANAGEMENT_STATE';

export const GET_ALL_INVESTORS = 'GET_ALL_INVESTORS';
export const GET_ALL_INVESTORS_SUCCESS = 'GET_ALL_INVESTORS_SUCCESS';
export const GET_ALL_INVESTORS_ERROR = 'GET_ALL_INVESTORS_ERROR';

export const GET_INVESTOR_BY_ID = 'GET_INVESTOR_BY_ID';
export const GET_INVESTOR_BY_ID_SUCCESS = 'GET_INVESTOR_BY_ID_SUCCESS';
export const GET_INVESTOR_BY_ID_ERROR = 'GET_INVESTOR_BY_ID_ERROR';

export const CREATE_INVESTOR = 'CREATE_INVESTOR';
export const CREATE_INVESTOR_SUCCESS = 'CREATE_INVESTOR_SUCCESS';
export const CREATE_INVESTOR_ERROR = 'CREATE_INVESTOR_ERROR';

export const UPDATE_INVESTOR = 'UPDATE_INVESTOR';
export const UPDATE_INVESTOR_SUCCESS = 'UPDATE_INVESTOR_SUCCESS';
export const UPDATE_INVESTOR_ERROR = 'UPDATE_INVESTOR_ERROR';

export const DELETE_INVESTOR = 'DELETE_INVESTOR';
export const DELETE_INVESTOR_SUCCESS = 'DELETE_INVESTOR_SUCCESS';
export const DELETE_INVESTOR_ERROR = 'DELETE_INVESTOR_ERROR';

export const GET_USERS_BY_INVESTOR = 'GET_USERS_BY_INVESTOR';
export const GET_USERS_BY_INVESTOR_SUCCESS = 'GET_USERS_BY_INVESTOR_SUCCESS';
export const GET_USERS_BY_INVESTOR_ERROR = 'GET_USERS_BY_INVESTOR_ERROR';
